import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PortalAuthShell from '../../components/PortalAuthShell';

export default function PortalLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setError('');
    try {
      const res = await fetch(`${backendUrl}/api/portal/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Invalid credentials');
      localStorage.setItem('portal_token', data.access_token);
      localStorage.setItem('portal_client_id', data.client.id);
      localStorage.setItem('portal_client_name', data.client.name);
      localStorage.setItem('portal_client_email', data.client.email);
      navigate('/portal/dashboard');
    } catch (e) { setError(e.message); }
    finally { setSubmitting(false); }
  };

  return (
    <PortalAuthShell>
      <div>
        <h2 className="text-3xl font-bold text-gray-900">Welcome back</h2>
        <p className="text-gray-600 mt-2">Sign in to your Minchio Brothers Client Portal.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="portal-login-form">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
            <div className="relative">
              <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition" data-testid="portal-email-input" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
            <div className="relative">
              <i className="ri-lock-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition" data-testid="portal-password-input" />
            </div>
          </div>
          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-3 flex items-start gap-2">
              <i className="ri-error-warning-line mt-0.5"></i><span>{error}</span>
            </div>
          )}
          <button type="submit" disabled={submitting} data-testid="portal-login-btn" className="w-full text-white py-3 rounded-xl font-semibold text-[15px] transition disabled:opacity-50 shadow-lg shadow-teal-500/20 hover:shadow-teal-500/40" style={{ background: 'linear-gradient(135deg, #0d9488 0%, #0891b2 100%)' }}>
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <div className="mt-8 pt-6 border-t border-gray-100 text-center">
          <p className="text-xs text-gray-500">
            Don’t have an account? <span className="text-gray-700">Portal access is invitation-only.</span>
          </p>
          <Link to="/contact" className="inline-block mt-2 text-sm font-medium text-teal-600 hover:text-teal-700">Request access &rarr;</Link>
          <div className="mt-4">
            <Link to="/" className="text-xs text-gray-400 hover:text-gray-600"><i className="ri-arrow-left-line"></i> Back to main site</Link>
          </div>
        </div>
      </div>
    </PortalAuthShell>
  );
}
